export default {
  isNode: typeof process !== 'undefined',
  isBrowser: typeof window !== 'undefined',
}
